import { SelecteFile } from "types/Models/documents";

// Files picked from Inkle Documents already exist on the server and carry a
// uuid, only the ones coming from the device have to be uploaded
export const partitionInkleDocFiles = (
  files: (File | SelecteFile)[]
): { inkleDocIds: string[]; filesToUpload: File[] } => ({
  inkleDocIds: files
    .filter((file): file is SelecteFile => "uuid" in file)
    .map(({ uuid }) => uuid),
  filesToUpload: files.filter((file): file is File => !("uuid" in file)),
});
